import RocketCard from "../../Components/Rocket-card/RocketCard";
import "./Home.css";

function Home() {
	return (
		<div className="home-card-container">
			<div className="home-card-sub-container">
				<RocketCard />
			</div>
		</div>
	);
}

export default Home;
